/*
 * lp-prescription (zod)
 */
import { globalCreateExclude, globalUpdateExclude } from "../utils/constants"
import { createInsertSchema, createSelectSchema } from "drizzle-zod"
import * as z from "zod"
import { lpPrescriptions } from "./lp-prescription.schema"

/* Select */
export type LpPrescription = z.infer<typeof selectLpPrescriptionSchema>
export const selectLpPrescriptionSchema = createSelectSchema(lpPrescriptions)

/* Filters */
export type LpPrescriptionFilters = z.infer<typeof lpPrescriptionFiltersSchema>
export const lpPrescriptionFiltersSchema = z.object({
	id: z.string().optional(),
	prescriptionId: z.string().optional(),
	licencedProducerId: z.string().optional(),
	active: z.boolean().optional(),
})

/* Create */
export const createLpPrescriptionSchema = createInsertSchema(lpPrescriptions).partial(
	globalCreateExclude,
)
export type CreateLpPrescription = z.infer<typeof createLpPrescriptionSchema>

/* Update */
export const updateLpPrescriptionSchema = createInsertSchema(lpPrescriptions)
	.omit(globalUpdateExclude)
	.partial()
	.required({ id: true })
export type UpdateLpPrescription = z.infer<typeof updateLpPrescriptionSchema>
